<template>
  <DatePicker
    lang="he"
    v-model="formDate"
    @change="someDate"
    format="DD.MM.YYYY"
    :calendar-button="true"
    calendar-button-icon="fa fa-calendar"
    autocomplete="off"
    :disabled="disabled"
    :disabled-date="disabledDate"
  >
    <template #input="{ props, events }">
      <input
        v-bind="props"
        v-on="events"
        v-mask="'##.##.####'"
        placeholder="DD.MM.YYYY"
        v-model="setNewDate"
      />
    </template>
  </DatePicker>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/locale/he';
import 'vue2-datepicker/index.css';
import moment from 'moment';

export default {
  name: 'vDatepicker',
  components: {
    DatePicker
  },
  props: {
    format: {
      type: String,
      default: 'YYYY-MM-DD'
    },
    disabled: {
      default: false
    },
    date: {
      type: [String, Date]
    },
    disabledDate: {
      type: Function,
      default: () => {}
    }
  },
  data() {
    return {
      formDate: null,
      setNewDate: null
    };
  },
  watch: {
    date(val) {
      if (val) {
        this.formDate = new Date(val);
        this.setNewDate = this.convertDay(new Date(val), 'DD.MM.YYYY');
      }
    }
  },
  mounted() {
    if (this.date) {
      this.formDate = new Date(this.date);
      this.setNewDate = this.convertDay(new Date(this.date), 'DD.MM.YYYY');
    }
  },
  methods: {
    convertDay(val, format = this.format) {
      return moment(val).format(format);
    },
    someDate() {
      this.$emit('change', this.convertDay(this.formDate));
    }
  }
};
</script>

<style lang="scss">
html[dir='rtl'] {
  .mx-icon-calendar,
  .mx-icon-clear {
    left: 8px;
    right: auto;
  }
}

.mx-datepicker {
  .mx-input {
    border: 1px solid #cfd3de;
    height: 40px;
    line-height: 38px;
    padding: 0 8px;
    transition: 0.3s;
    appearance: none;
    background-color: transparent;
    font-family: 'Rubik', sans-serif;
    -webkit-appearance: none;
    -moz-appearance: none;
    display: block;
  }
}
</style>
